<h1 cds-text="title">{{titleText}}</h1>
<app-edit-platform [platform$]="platform" [mode$]="submissionMode"></app-edit-platform>
